<template>
  <div>
    <WsLoading
      v-if="isLoading.captcha"
      primary
    />
    <div
      v-else-if="
        img &&
        key &&
        !isLoading.captcha
      "
      class="lv-captcha__img-container"
    >
      <img
        :src="img"
        alt="captcha image"
        class="img"
      />
      <WsTextButton001
        no-padding
        :leadingIcon="'icon-retry'"
        class="ml-10"
        @click="$_getCaptchaImgAndKey()"
      />
    </div>
    <div v-else class="lv-captcha__warning">
      <LvText class="text">
        <i class="icon-warning" />
        {{$t('請耐心等待驗證碼更新')}}
      </LvText>
      <WsLoading
        primary
        class="ml-10"
      />
    </div>
    <StateInputButton
      v-model="captcha"
      rules="required"
      :title="$t('驗證碼')"
      :placeholder="$t('輸入')"
      :disabled="!img && !key"
      class="mt-5"
      @input="$emit('input', {key, captcha})"
      @enter="$emit('enter')"
    />
  </div>
</template>

<script>
import S_captcha from '@/service/api/v1/captcha';

export default {
  data() {
    return {
      isLoading: {
        captcha: false,
      },
      captcha: '',
      img: '',
      key: '',
    }
  },
  async mounted() {
    await this.$_getCaptchaImgAndKey();
  },
  methods: {
    async $_getCaptchaImgAndKey() {
      this.isLoading.captcha = true;
      try {
        const res = await S_captcha.getCaptcha();
        const {key, img} = res;
        this.key = key;
        this.img = img;
        this.$emit('input', {key, captcha: this.captcha});
      } catch (error) {
        this.key = '';
        this.img = '';
        setTimeout(()=> {return this.$_getCaptchaImgAndKey()}, 300000);
      } finally {
        this.isLoading.captcha = false;
      }
    },
  }
}
</script>